import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { FadeInAnimation } from '../shared/fade-in.animation';

@Component({
  selector: 'app-unsaved-dialog',
  templateUrl: './unsaved-dialog.component.html',
  styleUrls: ['./unsaved-dialog.component.scss'],
  animations: [FadeInAnimation]
})
export class UnsavedDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() { }

}


// WEBPACK FOOTER //
// ./src/app/transfers/unsaved-dialog.component.ts